import axios from 'axios';

const url = `${ process.env.VUE_APP_API_ROOT }/api/user/`;

// Note: Not used right now:
// const headers = {
//     'Authorization': `token ${process.env.VUE_APP_API_TOKEN}`,
// }

export default {
    login(credentials) {
        return axios
            .post(url + 'token/', credentials)
            .then(response => response.data);
    },
    signUp(credentials) {
        return axios
            .post(url + 'create/', credentials)
            .then(response => response.data);
    }
};